import { render, staticRenderFns } from "./CreateWalletMnemonicPhrase.vue?vue&type=template&id=fdd493f4&scoped=true"
import script from "./CreateWalletMnemonicPhrase.vue?vue&type=script&lang=js"
export * from "./CreateWalletMnemonicPhrase.vue?vue&type=script&lang=js"
import style0 from "./CreateWalletMnemonicPhrase.vue?vue&type=style&index=0&id=fdd493f4&prod&lang=scss"
import style1 from "./CreateWalletMnemonicPhrase.vue?vue&type=style&index=1&id=fdd493f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd493f4",
  null
  
)

export default component.exports